import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import MetadataDetails from "./MetadataDetails";
import { DataGridComponent } from "../../common/DataGridComponent";
import { ColumnType } from "../../../types/dataGridTypes";
import { useEntity } from "./useEntity";
import { useCodelist } from "../../../hooks/useCodelist";

const initialRows: GridRowsProp = [
  {
    id: crypto.randomUUID(),
    entity_name: "Study",
    parent: "-",
    desc: "Primary Entity for which data is pulled into the system",
  },
];

const MetadataPage = () => {
  const [rows, setRows] = useState(initialRows);

  const [selectedEntity, setSelectedEntity] = useState<any>(null);

  const { refetchGetAllEntities, getAllEntitiesData } = useEntity();

  useEffect(() => {
    if (!selectedEntity) {
      refetchGetAllEntities();
    }
  }, [selectedEntity]);

  const { getAllCodelists, allCodelistData } = useCodelist();

  useEffect(() => {
    getAllCodelists({});
  }, []);

  useEffect(() => {
    if (getAllEntitiesData && getAllEntitiesData?.length > 0) {
      setRows(
        getAllEntitiesData.map((item: any) => {
          return { ...item, id: crypto.randomUUID() };
        })
      );
    } else {
      setRows([]);
    }
  }, [getAllEntitiesData]);

  const columns: ColumnType[] = [
    {
      field: "entity_name",
      headerName: "Entity",
      width: 180,
      cmp: "link",
      flex: 1,
    },
    {
      field: "parent",
      headerName: "Parent",
      width: 220,
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 300,
      flex: 1,
    },
    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: "Actions",
    //   width: 100,

    // },
  ];

  const actions = {
    entity_name: (data: any) => {
      setSelectedEntity(data);
    },
  };

  return (
    <Box
      sx={{
        height: "calc(100vh - 240px)",
        width: "100%",
        "& .actions": {
          color: "text.secondary",
        },
        "& .textPrimary": {
          color: "text.primary",
        },
      }}
    >
      {selectedEntity ? (
        <MetadataDetails
          setSelectedEntity={setSelectedEntity}
          selectedEntity={selectedEntity}
          allCodelistData={allCodelistData}
        />
      ) : (
        <>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: -1, mb: 1 }}
          >
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setSelectedEntity("new")}
            >
              Add Entity
            </Button>
          </Box>
          <DataGridComponent
            rows={rows}
            columns={columns as any}
            hideFooter
            hideFooterRowCount
            hideFooterSelectedRowCount
            hideFooterPagination
            hasDefinedColumns={false}
            actions={actions}
            showQuickFilter
          />
        </>
      )}
    </Box>
  );
};

export default MetadataPage;
